import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Categories from "./Categories";
import Filter from "./Filter";

const Filters = props => {
  const {
    loading,
    filters,
    isFiltersVisible,
    setFiltersVisibility,
    category,
    partner,
    keyword
  } = props;

  useEffect(() => {
    const body = document.getElementsByTagName("body")[0];
    if (isFiltersVisible) {
      body.classList.add("is-fixed");
    } else {
      body.classList.remove("is-fixed");
    }
  }, [isFiltersVisible]);

  return (
    <section
      className={`products__filters ${isFiltersVisible ? "is-active" : ""}`}
    >
      <div className="products__filters-container">
        <header className="products__filters-header">
          <h4 className="products__filters-name">Filters</h4>
          <button
            type="button"
            className="products__filters-toggle"
            aria-label="See More See Less"
            onClick={() => setFiltersVisibility(false)}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </header>
        <div className="products__filters-body">
          {!partner && !keyword && <Categories id={category} />}
          {filters.map(filter => (
            <Filter
              key={filter.attributeCode}
              attributeCode={filter.attributeCode}
              attributeName={filter.attributeName}
              attributeValues={filter.attributeValues}
              partner={partner}
            />
          ))}
        </div>
        {loading && <div className="products__filters-loading" />}
      </div>
    </section>
  );
};

Filters.propTypes = {
  loading: PropTypes.bool.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape(Filter.propTypes)).isRequired,
  isFiltersVisible: PropTypes.bool.isRequired,
  setFiltersVisibility: PropTypes.func.isRequired,
  partner: PropTypes.string,
  category: PropTypes.number,
  keyword: PropTypes.string
};

Filters.defaultProps = {
  partner: null,
  category: null,
  keyword: null
};

export default Filters;
